export function ArtistBookingStatsViewModel(data) {

    var self = this;
    self.type = "ArtistBookingStatsViewModel";

    self.rootvm = data.rootvm;

    self.artists = ko.observableArray([]);

    self.initialized = ko.observable(false);
    self.initialize = function() {
        if (!self.initialized()) {
            self.lookup_stats().then(function() {
                self.initialized(true);
            });
        }
    };

    self.lookup_stats = function() {
        self.rootvm.is_busy(true);
        return $.ajax({
            url: self.rootvm.web_host + '/api/admin/artist-booking-stats',
            type: 'GET',
            contentType: "application/json; charset=utf-8",
            success: function(data) {
                self.artists(data.artists);
            },
            error: function() {},
            complete: function() {
                self.rootvm.is_busy(false);
            }
        });
    };

    self.fmtEuro = function(val) {
        if (!val || val == 0) return '—';
        return '€ ' + Math.round(val).toLocaleString('de-DE');
    };

    self.fmtNum = function(val) {
        if (!val || val == 0) return '—';
        return val;
    };
}
